<template>
    <div class="cp-home-brand">
        <div :style="{
            'background-image': 'url(' + data.bg + ')',
            'width': '100%',
            'height': '100vh',
            'background-size': 'cover'
        }"></div>
        <div class="cp-home-brand-content">
            <!-- 左侧 -->
            <div :class="[
                    'cp-home-brand-ani-start',
                    isRender ? 'cp-home-brand-ani-1' : ''
                ]">
                <div class="cp-home-brand-title">{{ data.title }}</div>
                <div class="cp-home-brand-text">
                    <span>已累计帮助用户解决问题</span>
                    <span class="cp-home-brand-num">{{ data.count }}</span>
                    <span>平均回复</span>
                    <span class="cp-home-brand-num">{{ data.speed }}</span>
                    <span>好评率</span>
                    <span class="cp-home-brand-num">{{ data.praise }}</span>
                </div>
                <img
                    class="cp-home-brand-qrcode"
                    :src="data.qrcode">
            </div>
            <div class="cp-home-brand-demo">
                <div
                    class="cp-home-brand-phone-wrap"
                    :class="[
                        'cp-home-brand-ani-start',
                        isRender ? 'cp-home-brand-ani-2' : ''
                    ]">
                    <div
                        class="cp-home-brand-phone-ke"
                        :style="{
                            'background-image': 'url(' + data.img + ')'
                        }"></div>
                    <video
                        :src="video"
                        :class="[
                            'cp-home-brand-phone'
                        ]"
                        autoplay
                        muted
                        id="cp-home-video"></video>
                </div>
                <!-- step -->
                <div
                    :class="[
                        'cp-home-brand-ani-start',
                        isRender ? 'cp-home-brand-ani-3' : ''
                    ]">
                    <div>
                        <span class="cp-home-brand-step-current">0{{ current + 1 }}</span>
                        <span class="cp-home-brand-step-total">/0{{ data.step.length }}</span>
                    </div>
                    <div v-for="(item, i) in data.step">
                        <div
                            v-for="(t, j) in item.text"
                            v-if="i === current"
                            style="margin-bottom: 8px;">{{ t }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'cp-header',
    components: {
    },
    props: {
        isInView: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            video: '',
            current: 0,
            seq: [0, 4000, 10000, 17000], // step每项停留的时间
            itvid: null,
            isRender: false
        }
    },
    watch: {
        isInView(v) {
            if (v) {
                this.video = this.data.video;
                this.play();
            }
            else {
                this.isRender = false;
                this.current = 0;
                this.video = '';
                clearInterval(this.itvid);

            }
        }
    },
    mounted() {
        document.title = '百度健康-问医生';
        this.video = this.data.video;
        this.play();
    },
    methods: {
        play() {
            if (this.isInView) {
                let time = setTimeout(() => {
                    this.isRender = true;
                    // 执行切换文案
                    let time2 = setTimeout(() => {
                        this.change();
                        clearTimeout(time2);
                    }, 500);
                    clearTimeout(time);
                }, 200);
            }
        },
        change() {
            let start = Date.now();
            this.itvid = setInterval(() => {
                if (this.current < this.data.step.length - 1) {
                    if (Date.now() - start >= this.seq[this.current + 1]) {
                        this.current = this.current + 1;
                    }
                }
                else {
                    clearInterval(this.itvid);
                }
            }, 1000);
        }
    }
}
</script>

<style scoped>
.cp-home-brand {
    position: relative;
}
.cp-home-brand-content {
    position: absolute;
    top: 0;
    bottom: 0;
    padding: 0 1.2rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
}
.cp-home-brand-title {
    font-size: .54rem;
    font-weight: bold;
}
.cp-home-brand-text {
    font-size: .24rem;
    margin-top: .24rem;
}
.cp-home-brand-num {
    font-size: .36rem;
    margin-right: .12rem;
}
.cp-home-brand-qrcode {
    margin-top: .64rem;
    width: 2.58rem;
    height: 2.58rem;
}
.cp-home-brand-demo {
    display: flex;
    align-items: center;
    font-size: .24rem;
    width: 7.2rem;
}
.cp-home-brand-phone-wrap {
    position: relative;
    width: 3.39rem;
    height: 6.9rem;
    margin-right: .72rem;
}
.cp-home-brand-phone-ke {
    position: absolute;
    width: 3.39rem;
    height: 6.9rem;
    background-size: contain;
    z-index: 50;
    background-repeat: no-repeat;
}
.cp-home-brand-phone {
    position: absolute;
    width: 3rem;
    left: .2rem;
    top: .12rem;
    right: .2rem;
}
.cp-home-brand-step-current {
    font-size: 1.2rem;
    font-weight: bold;
}
.cp-home-brand-step-total {
    font-size: .28rem;
    color: #d8d8d8;
    margin-bottom: .19rem;
    display: inline-block;
}
.cp-home-brand-ani-start {
    transform: translateX(2.8rem);
    opacity: 0;
}

.cp-home-brand-ani-1 {
    transition: all .6s ease-out;
    transform: translateX(0);
    opacity: 1
}
.cp-home-brand-ani-2 {
    transition: all .5s ease-out .3s;
    transform: translateX(0);
    opacity: 1
}
.cp-home-brand-ani-3 {
    transition: all .5s ease-out .5s;
    transform: translateX(0);
    opacity: 1
}
</style>



// WEBPACK FOOTER //
// src/components/home/Brand.vue